
define('app/board/views/optionAlertView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'app/board/models/draftOptionsModel',
	
	//Templates
	'text!app/board/templates/optionsColorPreviewTemplate.html'
], function($, _, Backbone, UserModel, LeagueInstanceModel, DraftOptionsModel, colorPreviewHtml){
	var OptionAlertTeamsFooterView = Backbone.View.extend({
		events: {
			'click #optionAlertTeamsFooterBtn': 'submitAlertTeamsForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showAlertTeamsForm();
			
			this.listenTo(this.event, 'default', this.showAlertTeamsForm);
			this.listenTo(this.event, 'defaultNoTeams', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll); 
			this.listenTo(this.event, 'error', this.showAlertTeamsForm); 
			this.listenTo(this.event, 'success', this.showAlertTeamsForm);			
		},
		
		hideAll: function () {
			$(this.el).hide();
		},
		
		submitAlertTeamsForm: function () {
			this.event.trigger("save");
		},
		
		showAlertTeamsForm: function () {
			$(this.el).show();
		}
	});
	
	var OptionAlertTeamsMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);  
			this.listenTo(this.event, 'saving', this.processing); 
			this.listenTo(this.event, 'error', this.error); 
			this.listenTo(this.event, 'success', this.success); 
			
		},
		
		hideAll: function() {
			$(this.el).hide();
			$(this.el).find('#optionAlertTeamsMessageError').hide();
			$(this.el).find('#optionAlertTeamsMessageProcessing').hide();
			$(this.el).find('#optionAlertTeamsMessageSuccess').hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertTeamsMessageError').show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertTeamsMessageSuccess').show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertTeamsMessageProcessing').show();
		}
	});
	
	var OptionAlertTeamsView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel;
			this.lgInst = options.lgInst;
			
			this.listenTo(this.userModel, 'change', this.render);
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			this.teamInputs = [];
			
			this.message = new OptionAlertTeamsMessageView({el: this.$("#optionAlertTeamsMessage"), event: this.event});
			this.footer = new OptionAlertTeamsFooterView({el: this.$("#optionAlertTeamsFooter"), event: this.event});
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.submitAlertTeams); 
			this.listenTo(this.event, 'default', this.showFormContent);  	
			this.listenTo(this.event, 'saving', this.hideAll); 
			this.listenTo(this.event, 'error', this.showFormContent); 
			this.listenTo(this.event, 'success', this.showFormContent); 
		},
		
		render: function () {
			this.addAllTeams();
			
			if(this.teamInputs.length == 0){
				this.event.trigger("defaultNoTeams");
			} else {
				this.event.trigger("default");
			}
			
			return this;
		},
		
		submitAlertTeams: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				
				for(var key in this.teamInputs){
					var team = this.lgInst.getTeam(key);
					team.set({notificationType: this.teamInputs[key].find('.optionAlertTeamInputSelect').val()}, {silent: true});
				}
				
				this.lgInst.get("fantasyTeams").saveChanges(this.successCallback, this.errorCallback);
			}
		},
		
		successCallback: function(model, response) {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}
		},
		
		errorCallback: function(error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");					
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		addTeam: function(team) {
			var teamElHtml = '<div class="optionAlertTeamInputContainer">'
				+ '<span>' + team.get('teamName') + '</span>'
				+ '<select name="tm' + team.get('id') + 'AlertSelect" class="optionAlertTeamInputSelect">'
				+ '<option value="NONE" selected="true">No Alerts</option>'
				+ '<option value="EMAIL">Email</option>'
				+ '</select>'
				+ '</div>';
			
			var teamEl = $(teamElHtml);
			teamEl.find('.optionAlertTeamInputSelect').val(team.get('notificationType'));
			$(this.el).find('#optionAlertTeamsContainer').append(teamEl);			
			this.teamInputs[team.get('id')] = teamEl;
			
		},
		
		addAllTeams: function() {
			var teamContainer = $(this.el).find('#optionAlertTeamsContainer');
			teamContainer.empty();
			this.teamInputs = [];
			
			if(!this.userModel.isGuest()){
				var teamList = this.lgInst.getUserTeams(this.userModel.get('userName'));
				_.each(teamList, function(team){
					this.addTeam(team);
				}, this);
			}			
			
			if(this.teamInputs.length == 0){
				teamContainer.append('<div class="optionAlertTeamInputContainer"><span>You do not own any teams</span></div>')
			}
		},
		
		hideAll: function() {
			$(this.el).find('#optionAlertTeamsContainer').hide();
		},
		
		showFormContent: function() {
			$(this.el).find('#optionAlertTeamsContainer').show();
		},
	});
	
	var OptionAlertEmailVerifyFooterView = Backbone.View.extend({
		events: {
			'click #optionAlertEmailVerifyFooterBtn': 'submitResendVerificationForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showResendVerificationForm();
			
			this.listenTo(this.event, 'default', this.hideAll); 
			this.listenTo(this.event, 'defaultNotActivated', this.showResendVerificationForm); 			
			this.listenTo(this.event, 'saving', this.hideAll); 
			this.listenTo(this.event, 'error', this.showResendVerificationForm); 
			this.listenTo(this.event, 'success', this.hideAll);			 
		},
		
		hideAll: function () {
			$(this.el).hide();
		},
		
		submitResendVerificationForm: function () {
			this.event.trigger("save");
		},
		
		showResendVerificationForm: function () {
			$(this.el).show();
		}
	});

	var OptionAlertEmailVerifyMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll); 
			this.listenTo(this.event, 'defaultNotActivated', this.hideAll); 
			this.listenTo(this.event, 'saving', this.processing); 
			this.listenTo(this.event, 'error', this.error); 
			this.listenTo(this.event, 'success', this.success); 
			
		},
		
		hideAll: function() {
			$(this.el).hide();
			$(this.el).find('#optionAlertEmailVerifyMessageError').hide();
			$(this.el).find('#optionAlertEmailVerifyMessageProcessing').hide();
			$(this.el).find('#optionAlertEmailVerifyMessageSuccess').hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertEmailVerifyMessageError').show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertEmailVerifyMessageSuccess').show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find('#optionAlertEmailVerifyMessageProcessing').show();
		}
	});
	
	var OptionAlertEmailVerifyView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel;
			
			this.listenTo(this.userModel, 'change', this.render);
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new OptionAlertEmailVerifyMessageView({el: this.$("#optionAlertEmailVerifyMessage"), event: this.event});
			this.footer = new OptionAlertEmailVerifyFooterView({el: this.$("#optionAlertEmailVerifyFooter"), event: this.event});
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.submitResendVerification); 
			this.listenTo(this.event, 'default', this.hideAll); 
			this.listenTo(this.event, 'defaultNotActivated', this.showNotActivated);
			this.listenTo(this.event, 'defaultGuest', this.hideAll);
			this.listenTo(this.event, 'saving', this.showActivationSent); 
			this.listenTo(this.event, 'error', this.showNotActivated); 
			this.listenTo(this.event, 'success', this.showActivationSent); 
		},
		
		render: function () {			
			if(this.userModel.get("activated")){
				this.event.trigger("default");
			} else if(!this.userModel.isGuest()){
				this.event.trigger("defaultNotActivated");				
			} else {
				this.event.trigger("defaultGuest");
			}
			
			return this;
		},
		
		submitResendVerification: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				
				var data = {
						userName: this.userModel.get('userName'), 
						activationType: "ACTIVATION"};				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/activations',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(data, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}
		},
		
		errorCallback: function(error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if(error.status == 409) {
					this.userModel.fetch();
				} else {
					this.event.trigger("error");					
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			$(this.el).find('#optionAlertEmailVerifyWarning').hide();
		},
		
		showActivationSent: function() {
			$(this.el).show();
			$(this.el).find('#optionAlertEmailVerifyWarning').hide();
		},
		
		showNotActivated: function() {
			$(this.el).show();
			$(this.el).find('#optionAlertEmailVerifyWarning').show();
		},
	});
	
	var OptionAlertEmailView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel;
			
			this.listenTo(this.userModel, 'change', this.render);
			
			this.verifyView = new OptionAlertEmailVerifyView({
				el: this.$("#optionAlertEmailVerifyContainer"),
				userModel: this.userModel
			});
			
			this.verifyView.render();
		},
		
		render: function () {
			if(this.userModel.get("activated")){
				$(this.el).find('#optionAlertEmailNotActivated').hide();
				$(this.el).find('#optionAlertEmailActivated').show();
				$(this.el).find('#optionAlertEmailDisplay').html(this.userModel.get("email"));
			} else if(!this.userModel.isGuest()){
				$(this.el).find('#optionAlertEmailActivated').hide();
				$(this.el).find('#optionAlertEmailNotActivated').show();				
				$(this.el).find('#optionAlertEmailDisplay').html(this.userModel.get("email"));
			} else {
				$(this.el).find('#optionAlertEmailNotActivated').hide();
				$(this.el).find('#optionAlertEmailActivated').hide();
				$(this.el).find('#optionAlertEmailDisplay').html('You are not logged in');
			}
			
			return this;
		},
	});
	
	var OptionAlertView = Backbone.View.extend({
		events: {
			'click #optionAlertEditBack': 'mainMenu',
		},
		
		initialize: function(options) {
			this.navEvent = options.event;
			this.lgInst = options.lgInst;
			this.userModel = options.userModel;
			
			this.hideAll();
			
			this.listenTo(this.navEvent, 'mainMenu', this.hideAll);
			this.listenTo(this.navEvent, 'alertMenu', this.alertMenu);
			
			
			this.alertEmailView = new OptionAlertEmailView({
				el: this.$("#optionAlertEmailContainer"),
				userModel: this.userModel
			});
			
			this.alertTeamsView = new OptionAlertTeamsView({
				el: this.$("#optionAlertTeamsContainer"),
				userModel: this.userModel,
				lgInst: this.lgInst
			});
			
			this.buildEl();
		},
		
		buildEl: function() {
			this.alertEmailView.render();
			this.alertTeamsView.render();
		},
		
		render: function () {			
			
			return this;
		},
		
		hideAll: function() {
			$(this.el).hide();
		},
		
		mainMenu: function() {
			this.navEvent.trigger("mainMenu");
		},
		
		alertMenu: function () {
			this.hideAll();
			$(this.el).show();
		},
	});
	
	return OptionAlertView;
});